<template>
    <!--    新闻模块-->
    <div class="container newIcon1">

        <el-row class="ordinary" :gutter="39">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="" class="positionRight"
                    style="margin-bottom: 25px">
                <!--                <div class="grid-content image-type" style="display: flex;justify-content: right;">-->
                <!--                    &lt;!&ndash;                                <el-image&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                        style="width: 100%; height: 400px"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                        :src="value"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                        class="scal"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                ></el-image>&ndash;&gt;-->
                <!--                    <div class="image">-->
                <!--                        <img class="scal" :src="value">-->
                <!--                    </div>-->
                <!--                </div>-->


                <div class="bigDiv">
                    <img :src="value">
                </div>

            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"
                    style="overflow: hidden;margin-bottom: 25px"
                    class="buttomPosition col positionLeft newIcon heightSm">
                <!--                <el-carousel  direction="vertical" class="contenrtDiv"  ref="nop" >-->
                <!--                    <el-carousel-item v-for="(item2, index2) in hxContentList" :key="index2">-->
                <!--                        <h3 class="medium">{{ item }}</h3>-->

                <!--                    </el-carousel-item>-->
                <!--                </el-carousel>-->


                <el-carousel
                        direction="vertical"
                        :interval="5000"
                        class="contenrtDiv"
                        style="width: 100%;"
                        ref="nop"
                        :autoplay="false"

                >

                    <el-carousel-item
                            v-for="(item2, index2) in hxContentList"
                            :key="index2"
                            style="height: 100%"
                    >
                        <!--                        style="display: flex;flex-direction: column;justify-content: space-between;"-->

                        <div
                                class="news-list"
                                style="display: flex;height: 33.34%;align-items: center;"
                                v-for="(item3, index3) in item2"
                                :key="index3"
                        >
                            <div
                                    class="news-item"
                                    @click="newsClick(item3.url)"
                            >
                                <div
                                        v-if="item3.sun"
                                        class="sun"
                                >
                                    {{ item3.sun }}
                                </div>
                                <div
                                        class="calendar"
                                        v-if="item3.calendar"
                                >
                                    {{ item3.calendar }}
                                </div>
                            </div>

                            <div class="news" style="margin-left: 20px;overflow: hidden;height: 100%;">
                                <div
                                        v-if="item3.title"
                                        @click="newsContent(item3)"
                                        class="news-title"
                                >
                                    {{ item3.title }}
                                </div>
                                <div
                                        class="ql-editor news-content firstLine"
                                        v-if="item3.content"
                                        v-html="item3.content"
                                ></div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div class="btndiv" style="width: 100%;">
                    <button type="button" class="upButtom" @click="prev()" style="margin-right: 15px"><i
                            class="el-icon-arrow-up"></i></button>
                    <button type="button" class="downButtom" @click="prev()"><i class="el-icon-arrow-down"></i></button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "myNews",
        props: {
            hxContentList: {
                type: Array,
                default: null
            },
            // 新闻图片路径
            value: {
                type: String,
                default: null
            },
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {
            prev() {
                this.$refs.nop.prev();
            },
            next() {
                this.$refs.nop.next();
            },
            newsClick(url) {
                this.$emit('input', url)
            },
            // 跳转新闻详情
            newsContent(data) {
                this.$router.push({
                    path: "/news",
                    query: {
                        contentId: data.contentId,
                    },
                });
            },
        }
    }
</script>

<style lang="scss">
    .newIcon1 {
        .el-carousel__container {
            height: 100%;
        }
    }

    //.buttomPosition {
    //  .el-carousel__arrow--left {
    //       left: -10px;
    //       z-index: 999;
    // }

    //.el-carousel--horizontal {
    //  overflow-x: unset;
    // }

    //.el-carousel__arrow--right {
    //right: -1px;
    //z-index: 999;

    //}


    //}

    //.newIcon {
    //  .el-carousel__container {
    //padding: 0 25px;
    //}
    //.news-list{
    //  margin: 0 26px;
    //}

    //}

    /*@media screen and (max-width: 570px) {*/
    /*    .buttomPosition {*/
    /*        .el-carousel__arrow--left {*/
    /*          //  left: -10px;*/
    /*            z-index: 999;*/

    /*        }*/


    /*        .el-carousel__arrow--right {*/
    /*          //  right: -10px;*/
    /*            z-index: 999;*/

    /*        }*/
    /*    }*/

    /*}*/

</style>
<style scoped lang="scss">
    .btndiv {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 15%;

    }

    .upButtom {
        border: none;
        outline: 0;
        padding: 0;
        margin: 0;
        max-height: 36px;
        height: 100%;
        /*width: 36px;*/
        aspect-ratio: 1/1;

        cursor: pointer;
        transition: .3s;
        border-radius: 50%;
        background-color: rgba(31, 45, 61, .11);
        color: #FFF;
        /*position: absolute;*/
        /*top: 50%;*/
        z-index: 10;
        /* transform: translateY(-50%);*/
        text-align: center;
        font-size: 12px;


    }

    .downButtom {
        border: none;
        outline: 0;
        padding: 0;
        margin: 0;
        height: 100%;
        max-height: 36px;

        /*width: 36px;*/
        aspect-ratio: 1/1;

        cursor: pointer;
        transition: .3s;
        border-radius: 50%;
        background-color: rgba(31, 45, 61, .11);
        color: #FFF;
        /*position: absolute;*/
        /*top: 50%;*/
        z-index: 10;
        /*transform: translateY(-50%);*/
        text-align: center;
        font-size: 12px;

    }

    /*.el-carousel__item h3 {*/
    /*    color: #475669;*/
    /*    font-size: 14px;*/
    /*    opacity: 0.75;*/
    /*    line-height: 200px;*/
    /*    margin: 0;*/
    /*}*/

    /*.el-carousel__item:nth-child(2n) {*/
    /*    background-color: #99a9bf;*/
    /*}*/

    /*.el-carousel__item:nth-child(2n+1) {*/
    /*    background-color: #d3dce6;*/
    /*}*/
    .bigDiv {
        position: relative;
        overflow: hidden;
        /*width: 80%;*/
        aspect-ratio: 15/8;
        /*height: 350px;*/
    }

    .positionLeft {
        /*display: flex;*/
        /*justify-content: left;*/
    }

    .positionRight {
        display: flex;
        justify-content: right;
    }

    .contenrtDiv {
        width: 100%;
        /*width: 80%;*/
        /* aspect-ratio: 15/8;*/
        /*height: 100%;*/
        height: 85%
    }

    .ordinary {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        /*height: 350px;*/
        /*width: 80%;*/
        /*overflow-y: hidden;*/
        /*margin: 10px 10px 0 10px;*/

    }

    .container {
        width: 70%;
    }

    /*.news-item {*/
    /*    width: 90px;*/
    /*    height: 90px;*/
    /*}*/


    @media screen and (min-width: 1400px) {
        /*.news-item{*/
        /*    width: 80px;*/
        /*    height: 80px;*/
        /*}*/
        .bigDiv {
            /*width: 70%;*/
        }
        .container {
            width: 70%;
        }
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .image {
            height: 350px;
            width: 60%;
        }

        .image-type {
            padding: 0 20px;
        }

        /*.col-content {*/
        /*    width: 60%;*/
        /*    padding: 0 20px;*/
        /*}*/

    }

    @media screen and (min-width: 1200px) {
        /*.container {*/
        /*    width: 70%;*/
        /*}*/

        .image-type {
            padding: 0 20px;
        }
    }

    @media screen and (max-width: 1200px) {
        .container {
            width: 70%;
        }
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .image {
            height: 350px;
            width: 90%;
        }

        .image-type {
            padding: 0 10px 0 30px;
        }

        .buttomPosition {
            padding: 0 20px;
        }
        .bigDiv {
            /*width: 90%;*/
        }

    }

    @media screen and (max-width: 992px) {
        .heightSm {
            height: 350px;
        }
        .sun{
            font-size: 18px;
        }
        .calendar{
            font-size: 14px;
        }
    }

    @media screen and (max-width: 994px) {
        .positionLeft {
            /*justify-content: center;*/
            /*padding-left: 0px !important;*/
        }
        .positionRight {
            justify-content: center;
        }
        .news-item {
            /*width: 80px;*/
            /*height: 80px;*/
        }
    }

    @media screen and (max-width: 870px) {
        .heightSm {
            height: 280px;
        }
        .container {
            width: 90%;
        }
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .image {
            height: 200px;
            width: 100%;
        }

        .image-type {
            padding: 0 20px;
        }

        .buttomPosition {
            padding: 0 20px;
        }
        .bigDiv {
            /*width: 100%;*/
        }
        /*.padding0{*/
        /*    padding-left: 25px!important;*/
        /*    padding-right: 25px!important;*/

        /*}*/
        /*.ordinary {*/
        /*    width: 100% !important;*/
        /*    margin-left: unset!important;*/
        /*    margin-right: unset!important;*/

        /*}*/
    }

    @media screen and (max-width: 570px) {
        .heightSm {
            height: 230px;
        }
        .container {
            width: 90%;
        }
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .image {
            height: 200px;
            width: 100%;
        }

        .image-type {
            padding: 0 20px;
        }

        .buttomPosition {
            padding: 0 20px;
        }
        .bigDiv {
            /*width: 100%;*/
        }
    }

    /*首行缩进*/
    .firstLine {
        text-indent: 2em;
        line-height: 28px;
        /*width: 90%;*/
    }

    .news-content {
        /*font-size: 14px;*/
        color: #999;
        padding: 0 20px;
        line-height: 1.5;
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /*height: 40px;*/
        height: auto;

    }


    .bigDiv img {
        /*height: 100%;*/
        width: 100%;
        transition: all .3s;
        /*height: 100%;*/
        /*height: 400px;*/
    }

    .bigDiv .zhe {
        width: 100%;
        height: 100%;
        background: rgb(0, 0, 0, 0.07);
        /*background: red;*/
        position: absolute;
        top: 100%;
        transition: all .6s;
        z-index: 999;
        color: #fff;
        font-family: cursive;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        flex-direction: column-reverse;
    }

    .bigDiv:hover img {
        transform: scale(1.1);
    }

    .bigDiv:hover .zhe {
        top: 0;
    }

    .ql-editor {
        padding: 0 0 !important;
    }

    .scal {
        overflow: hidden;

        img {
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    .el-image {

        img {
            height: 100%;
            width: 100%;
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }

    }

    .news-title {
        color: #0094ff;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    /*@media screen and (max-width: 1400px) {*/
    /*.news-item {*/
    /*    width: 85px;*/
    /*    height: 85px;*/
    /*}*/

    .sun {
        font-size: 20px;
        color: white;
    }

    .calendar {
        font-size: 16px;
        color: white
    }

    .news-title {
        font-size: 16px;
    }

    .sun {
        font-size: 20px;
        color: white;
    }

    /*}*/

    @media screen and (max-width: 1400px) {
        .sun {
            font-size: 16px;
        }
        .calendar {
            font-size: 12px;
        }
        .newIcon .el-carousel__container {
            height: 280px !important;
        }
        /*.news-item {*/
        /*    width: 72px;*/
        /*    height: 72px;*/
        /*}*/
        .sun {
            font-size: 20px;
            color: white;
        }

        .calendar {
            font-size: 13px;
            color: white
        }

        .news-title {
            font-size: 16px;
        }
        .scal {
            width: 100%;
            height: 100%;
        }
        .sun {
            font-size: 18px;
            color: white;
        }
        .news-list {

        }

    }

    @media screen and (max-width: 1200px) {

        .sun {
            font-size: 14px;
            color: white;
        }
        .scal {
            width: 100%;
            height: 100%;
        }
        .news-title {
            font-size: 16px;
        }
        /*.news-item {*/
        /*    width: 55px;*/
        /*    height: 55px;*/
        /*}*/
        .news-content {
            margin-top: 5px;
            /*height: 33px;*/
            height: auto;

        }
        .calendar {
            font-size: 12px;
            color: white
        }
        .news-list {

        }
    }

    @media screen and (max-width: 985px) {
        .sun {
            font-size: 18px;
            color: white;
        }
        .news-title {
            font-size: 16px;
        }
        .news {
            width: 80%;
        }
        /*.news-item {*/
        /*    width: 90px;*/
        /*    height: 90px;*/
        /*}*/
        .news-list {

        }
        .news-content {
            /*margin-top: 10px;*/
            /*height: 43px;*/
        }
    }

    @media screen and (max-width: 870px) {
        .sun {
            font-size: 18px;
            color: white;
        }
        .scal {
            width: 100%;
            height: 100%;
        }
        .news-title {
            font-size: 16px;
        }
        .news {
            width: 80%;
        }
        /*.news-item {*/
        /*    width: 75px;*/
        /*    height: 75px;*/
        /*}*/
        .ordinary {
            margin: 10px 25px 0 25px;

        }
    }

    @media screen and (max-width: 620px) {
        /*.news-item {*/
        /*    width: 65px;*/
        /*    height: 65px;*/
        /*}*/
    }

    @media screen and (max-width: 570px) {
        .sun {
            font-size: 16px;
            color: white;
        }
        .scal {
            width: 100%;
            height: 200px;
        }
        .news-title {
            font-size: 14px;
        }
        .news {
            width: 80%;
        }
        /*.news-item {*/
        /*    width: 70px;*/
        /*    height: 70px;*/
        /*}*/
    }

    @media screen and (max-width: 466px) {
        /*.news-item {*/
        /*    width: 60px;*/
        /*    height: 60px;*/
        /*}*/
    }

    @media screen and (max-width: 466px) {
        /*.news-item {*/
        /*    width: 50px;*/
        /*    height: 50px;*/
        /*}*/
    }

    .news-list {
        cursor: pointer;
        transition: 0.5s;

        &:hover {
            transform: translateY(-4px);
        }
    }

    .news-item {
        background: #0094ff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex-shrink: 0;
        height: 90%;
        aspect-ratio: 1/1;
    }

    .el-image {

        img {
            height: 100%;
            width: 100%;
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }

    }

    .about-us-content {
        padding: 20px 0;
        // width: 65%;
        .image {
            display: flex;
            justify-content: right;
        }

        .about-us-content-title {
            display: flex;
            flex-direction: column;
            //   width: 100%;

            .about-us-content-title-text {
                // font-weight: bold;
                color: #333;
                font-size: 18px;
                width: 350px;
            }

            .about-us-content-title-subtitl {
                font-size: 14px;
                padding: 10px 0;
                line-height: 26px;
                color: #999;

                // width: 350px;
            }

            .about-us-content-title-content {
                color: #333;
                font-size: 14px;
                line-height: 26px;
                word-wrap: normal;
                // width: 320px;
                overflow-x: hidden;
                margin: 10px 0;
            }
        }
    }
</style>
                                                                                                                                                                                                                                                                                                                                                                                             
